// extracted by mini-css-extract-plugin
module.exports = {"figureContainer":"Figure_figureContainer__Ewpsl"};